import { IconButton } from "@xapp/chat-widget-core";
import React, { FC, MouseEvent } from "react";
import { SendIcon } from "../Icons";
import "./SendButton.scss";

export interface Props {
    className?: string;
    sendButtonIcon?: string;
    tabIndex?: string;
    onClick(e: MouseEvent): void;
}

const SendButton: FC<Props> = (props) => {
    return (
        <>
            {!props.sendButtonIcon ? (
                <IconButton
                    className={`xappw-send-button ${props.className || ""}`}
                    tabIndex={props.tabIndex}
                    onClick={props.onClick}
                    icon={SendIcon}
                />
            ) : (
                <button className="xappw-custom-send-button" tabIndex={props.tabIndex ? Number(props.tabIndex) : 0} onClick={props.onClick}>
                    <img src={props.sendButtonIcon} alt="Send button" draggable={false} />
                </button>
            )}
        </>
    );
};

export default SendButton;
